import React, { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, getUser, setToken, setUser as saveUser } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUserState] = useState(getUser());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Refresh me on mount if token present
    (async () => {
      if (!getToken()) return;
      try {
        setLoading(true);
        const { data } = await api.get("/auth/me");
        saveUser(data.user);
        setUserState(data.user);
      } catch (e) {
        setToken(null);
        saveUser(null);
        setUserState(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = (token, u) => {
    setToken(token);
    saveUser(u);
    setUserState(u);
  };

  const logout = () => {
    setToken(null);
    saveUser(null);
    setUserState(null);
  };

  const refreshUser = async () => {
    if (!getToken()) return null;
    try {
      const { data } = await api.get("/auth/me");
      saveUser(data.user);
      setUserState(data.user);
      return data.user;
    } catch (e) {
      return null;
    }
  };

  return (
    <AuthCtx.Provider value={{ user, setUser: setUserState, login, logout, loading, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
